import { headerMobileMutationObserver, headerMutationObserver, menuOpenMutationObserver } from "./DOMObservers";
// import {reAlignCookieConsentBasedOnGeoRibbon} from "./geoRedirectCookieConsent";
import debounce from 'lodash/debounce';

$(document).ready(function () {

	/**
	 * Run the header mutation observer and run it always.
	 */
	headerMutationObserver();
	headerMobileMutationObserver();
	menuOpenMutationObserver();
	// reAlignCookieConsentBasedOnGeoRibbon();

	const appHeight = () => document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
	const headerMobileHeight = () => {
		const headerMobileEle = document.querySelector('.header-mobile');
		if (headerMobileEle) {
			document.documentElement.style.setProperty('--header-mobile-height', `${headerMobileEle.offsetHeight}px`)
		}
	}
	const headerDesktopHeight = () => {
		const headerTopbarEle = document.querySelector('.header-topbar');
		if (headerTopbarEle) {
			document.documentElement.style.setProperty('--header-topbar-height', `${headerTopbarEle.offsetHeight}px`)
		}
	}

	const adminBarHeight = () => {
		const adminBarEle = document.querySelector('#wpadminbar');
		if (adminBarEle) {
			document.documentElement.style.setProperty('--admin-bar-height', `${adminBarEle.offsetHeight}px`);
		} else {
			document.documentElement.style.setProperty('--admin-bar-height', `0px`)
		}
	}

	/**
	 * Get the height of the breadcrumb
	 */
	const subNavWrapperHeight = () => {
		const subNavEle = document.querySelector('.sub-navigation-wrapper');
		if (subNavEle) {
			document.documentElement.style.setProperty('--sub-navigation-wrapper-height', `${subNavEle.offsetHeight}px`);
		} else {
			document.documentElement.style.setProperty('--sub-navigation-wrapper-height', `0px`)
		}
	}

	window.addEventListener('resize', () => {
		appHeight();
		subNavWrapperHeight();
		headerDesktopHeight();
		adminBarHeight();
		headerMobileHeight();
	})
	appHeight();
	subNavWrapperHeight();
	headerMobileHeight();
	headerDesktopHeight();
	adminBarHeight();


	$('.header-topbar').hover(function () {
		$('.header-topbar').addClass('hover')
		$('.dark-gradient').addClass('hover')
		$('.light-gradient').addClass('hover')
	}, function () {
		$('.header-topbar').removeClass('hover')
		$('.dark-gradient').removeClass('hover')
		$('.light-gradient').removeClass('hover')
	})

	$('.light-gradient').hover(function () {
		$('.header-topbar').addClass('hover')
	}, function () {
		$('.header-topbar').removeClass('hover')
	})

	$('.dark-gradient').hover(function () {
		$('.header-topbar').addClass('hover')
	}, function () {
		$('.header-topbar').removeClass('hover')
	})


	let cgTopMenuItems = $('.header-topbar ul.menu > li');
	let cgSubNavigation = $('.sub-navigation');
	let cgBreadcumbShadow = cgSubNavigation.css('box-shadow');

	cgTopMenuItems.hover(function () {

		cgSubNavigation.css('box-shadow', 'none');
	});

	cgTopMenuItems.mouseleave(function () {

		cgSubNavigation.css('box-shadow', cgBreadcumbShadow);

	});

	// --- Mega-menu (desktop) ---
	$('.header-topbar-wrapper').hover(function () {
		$('.header-topbar').addClass('hover')
		// setTimeout(function(){
		//   if ($('.header-nav li:hover').length > 0) {
		//     $('.body-overlay').fadeIn(100)
		//   }
		// }, 200)
	}, function () {
		$('.header-topbar').removeClass('hover');
		const menuSubmenu = $('.header-bottom .header-nav li .menu-submenu')
		if (menuSubmenu) {
			menuSubmenu.removeClass('menu-open');
			menuSubmenu.attr('aria-expanded', false);
		}
		$(".header-bottom .header-nav li .menu-arrow-down").attr("aria-expanded", "false");
		// setTimeout(function(){
		//   if ($('.header-nav li:hover').length <= 0) {
		//     $('.body-overlay').fadeOut(100, function(){
		//       $('.header-topbar').removeClass('hover')
		//     })
		//   }
		// }, 200)
	});

	/**
	 *
	 * @param {Event<HTMLButtonElement>} e
	 * @param {Boolean} hide
	 */
	const toggleSubMenu = (e, hide = false) => {
		/**
		 * Get the clicked target
		 * @type {HTMLButtonElement}
		 */
		const clickedButton = e.target;

		/**
		 *
		 * @type {HTMLElement}
		 */
		const parentLi = clickedButton.parentElement;

		/**
		 * Get the submenu
		 * @type {HTMLElement}
		 */
		const subMenu = parentLi ? parentLi.querySelector('.menu-submenu') : null;

		if (subMenu && subMenu.classList.contains('menu-open')) {
			subMenu.classList.remove('menu-open');
			subMenu.ariaExpanded = false;
			clickedButton.ariaExpanded = false;
		} else {
			subMenu.classList.add('menu-open');
			subMenu.ariaExpanded = true;
			clickedButton.ariaExpanded = true;
		}
	}

	const headerTopbarNode = document.querySelector('.header-topbar');

	const menuArrowDownNode = headerTopbarNode ? headerTopbarNode.querySelectorAll('.menu-arrow-down') : [];
	menuArrowDownNode.forEach((menuArrowDownItem) => {
		menuArrowDownItem.addEventListener('click', toggleSubMenu)
	})

	const menuNavLiNodes = headerTopbarNode.querySelectorAll('.header-bottom .header-nav li');

	menuNavLiNodes.forEach((menuLiEle) => {
		menuLiEle.addEventListener('mouseenter', (e) => {
			const subMenu = e.currentTarget.querySelector('.menu-submenu');
			if (subMenu) {
				subMenu.classList.add('menu-open');
				subMenu.ariaExpanded = true;
			}
		})
		menuLiEle.addEventListener('mouseleave', (e) => {
			const subMenu = e.currentTarget.querySelector('.menu-submenu');
			if (subMenu) {
				subMenu.classList.remove('menu-open');
				subMenu.ariaExpanded = false;
			}
		})
	})



	$(".menu>li>a").addClass("menu-acc");
	$(".menu-acc").focus(function (e) {
		if ($(".menu-submenu").hasClass("menu-open")) {
			$('.menu-submenu').removeClass("menu-open");
			$(".menu-arrow-down").attr("aria-expanded", "false");
		}
	});

	const closeOpenItems = () => {
		const subMenus = headerTopbarNode ? headerTopbarNode.querySelectorAll('.menu-submenu') : [];
		subMenus.forEach((el) => {
			if (el.classList.contains('menu-open')) {
				el.classList.remove('menu-open');
				el.ariaExpanded = false;
			}
		})
	}

	document.addEventListener('keydown', (e) => {
		//e.keyCode is deprecated so use with e.code
		if (e.code === 'Escape' || e.keyCode === 27) {
			closeOpenItems();
		}
	})


});

// --- Mobile menu (mobile) ---

// Open/Close navigation - Mobile Menu will not closed until user clicks on close icon.

$('.mobile-nav-button').click(function () {

	var _this = $(this);

	// Sub navigation has the same z-index - it should be changed before sliding down
	if (!_this.hasClass('opened')) {
		$('.header-mobile, .header-mobile-bar').css('z-index', 105);
	} else {
		$('.header-mobile, .header-mobile-bar').css('z-index', 103);
	}
	// If header search is opened - close it
	if ($('.header-search').hasClass('active')) {
		$('.mobile-search-button').click();
	}

	_this.toggleClass('opened');

	const headerMobileBar = $('.header-mobile-bar');

	headerMobileBar.addClass('opened');

	$('.mobile-nav').slideToggle(
		// After sliding up, change the z-index so the sub navigation shadow is visible
		function () {
			if (!_this.hasClass('opened') && !$('.header-search').hasClass('active')) {
				$('.header-mobile').css('z-index', 103);
				headerMobileBar.removeClass('opened');
			}
		}
	)

	$('body').toggleClass('nooverflow');

	$('.body-overlay').fadeToggle();
});

// Show submenu (slide to the right)

$('.mobile-menu .menu-parent > a').click(function (e) {
	e.preventDefault()
	var mySubmenu = $(this).parent().find('> .menu-submenu')
	mySubmenu.show()
	var newLeft = parseInt($('.mobile-menu').css('left')) - mySubmenu.position().left
	$('.mobile-menu').css('left', newLeft)
})

// Hide submenu (slide to the left)

$('button.menu-submenu-back, li.menu-submenu-back a').click(function (e) {
	e.preventDefault()
	var mySubmenu = $(this).parents('.menu-submenu').first(),
		newSubmenu
	if ($(this).parent().hasClass('menu-submenu-title-wrapper')) {
		newSubmenu = $(this).parents('.menu-l0')
	} else {
		newSubmenu = $(this).parents('.menu-l1')
	}
	var newLeft = parseInt($('.mobile-menu').css('left')) + newSubmenu.width()
	$('.mobile-menu').css('left', newLeft)
	setTimeout(function () {
		mySubmenu.hide()
	}, 500)
})

// Sub-navigation mobile button

$('.subnav-mobile-button').click(function (e) {
	e.preventDefault()
	$(this).toggleClass('opened')
	$(this).parent().find('> ul').slideToggle()
})

// --- Resizing function for menus ---

var myScreenSize = getScreenSize()

function getScreenSize() {
	if ($(window).width() > 767) {
		return 'M'
	} else {
		return 'S'
	}
}

// Remove all classes and styles to hide menus when we change screen type

$(window).resize(debounce(
	function () {
		var newSize = getScreenSize()

		if (newSize != myScreenSize) {
			$('.body-overlay, .mobile-nav, .mobile-menu, .menu-submenu, .menu-submenu2, .sub-navigation > ul, .sub-navigation .menu-parent nav').attr('style', '')
			$('body').removeClass('nooverflow')
			$('.header-topbar-wrapper .header-nav a, .header-mobile-bar, .mobile-nav-button, .sub-navigation .menu-parent, .subnav-mobile-button').removeClass('opened')
			$('.menu-parent').removeClass('active')
		}

		myScreenSize = getScreenSize()
	}, 100
))

// --- Search menu ---

// Open search menu

$('.header-search-open').click(function () {
	if ($('.mobile-nav').is(':visible')) {
		$('.mobile-nav-button').click()
	}
	$('.header-search, .mobile-search-button').addClass('active');
	$('.header-mobile-bar').addClass('opened')
	$('.header-mobile, .header-mobile-bar').css('z-index', 104)
	$('body').addClass('nooverflow')
	$('.body-overlay2').fadeIn()
	$('.common-top-search-input').focus();
})

// Close Search on Esp key

$(document).keyup(function (e) {
	if (e.which == 27) {
		$(".header-search").removeClass('active');
		$('body').removeClass('nooverflow');
		$('.body-overlay2').fadeOut();
	}
});

// Close search menu

$('.header-search-close, .body-overlay2').click(function (e) {
	e.preventDefault()
	$('.header-search, .mobile-search-button').removeClass('active');
	$('.header-mobile-bar').removeClass('opened')
	$('.header-mobile, .header-mobile-bar').css('z-index', 103)
	$('.body-overlay2').fadeOut()
	$("div.demo").scrollTop(300);
	if (!$('.mobile-nav').is(':visible')) {
		$('body').removeClass('nooverflow')
	}
})

// Show results

function showSearchResults() {
	$('.header-search-bottom').hide()
	$('.header-search-results').show()
}

$('.header-search .form--oneliner input').on('keyup', function () {
	showSearchResults()
})


// Click search button

$('.header-search input[type="submit"]').click(function (e) {
	e.preventDefault()
	showSearchResults()
})

// --- Lang menu ---

// Open lang menu

$('.header-lang-open').click(function () {
	$('.header-lang').addClass('active')
	$('body').addClass('nooverflow')
	$('.body-overlay-on-lang').fadeIn()
	let cgSubNavigationWrapper = $('.sub-navigation-wrapper');

	if (cgSubNavigationWrapper.length > 0) {
		cgSubNavigationWrapper.addClass('below-header')
	}
})

// Close lang menu

$('.header-lang-close, .body-overlay-on-lang').click(function () {
	$('.header-lang').removeClass('active')
	$('.header-topbar').removeClass('hover')
	$('.body-overlay-on-lang').fadeOut()
	if (!$('.mobile-nav').is(':visible')) {
		$('body').removeClass('nooverflow')
	}
	let cgSubNavigationWrapper = $('.sub-navigation-wrapper');

	if (cgSubNavigationWrapper.length > 0) {
		cgSubNavigationWrapper.removeClass('below-header')
	}
})

// Choose language

$('.lang-list li button').click(function () {
	$('.lang-list li').removeClass('active')
	$(this).parent().addClass('active')
	$('.lang-current').empty().text($(this).text())
	$('.header-lang-close').click()
})

// Get width for lang list (must keep grid columns)

// function langMenuResizer() {
// 	if ( $( window ).width() > 767 ) {
// 		$( '.header-lang-middle, .lang-list ul' ).width( $( '.container' ).width() / 3 )
// 	} else {
// 		$( '.header-lang-middle, .lang-list ul' ).width( '100%' )
// 	}
// }

// $( window ).resize( lodash.debounce(
// 	function () {
// 		langMenuResizer()
// 	}, 100 ) )
//
// langMenuResizer()

function MenuWidthCalc() {
	if (Math.round(window.devicePixelRatio * 100) == 150) {
		$(".advertImageWrapper").addClass('advertImageWrapper150 ');
	}
	if ($(window).width() > 767) {
		$(".header-topbar-wrapper .menu-l2").each(function () {
			// Test if the div element is empty

			let childElementCount = this.children.length;
			if (childElementCount > 9) {
				$(this).addClass('menu-l2-large ' + childElementCount);
			} else {
				let largeTxtArray = [];
				for (let i = 0; i < this.children.length; i++) {
					if ((
						Math.round(window.devicePixelRatio * 100) == 100
					)) {
						if (this.children[i].innerText.length > 39) {
							largeTxtArray.push(this.children[i])
						}
					} else if (Math.round(window.devicePixelRatio * 100) == 110) {
						if (this.children[i].innerText.length > 34) {
							largeTxtArray.push(this.children[i])
						}
					} else if ((
						Math.round(window.devicePixelRatio * 100) == 125
					) || Math.round(window.devicePixelRatio * 100) == 150) {
						if (this.children[i].innerText.length > 27) {
							largeTxtArray.push(this.children[i])
						}
					}

				}
				if (this.children.length === 9 && largeTxtArray.length >= 1) {
					$(this).addClass('menu-l2-large ' + childElementCount);
					largeTxtArray = [];
				} else if (this.children.length === 8 && largeTxtArray.length > 2) {
					$(this).addClass('menu-l2-large ' + childElementCount);
					largeTxtArray = [];
				} else if (this.children.length === 7 && largeTxtArray.length > 4) {
					$(this).addClass('menu-l2-large ' + childElementCount);
					largeTxtArray = [];
				} else if (this.children.length === 6 && largeTxtArray.length > 5) {
					$(this).addClass('menu-l2-large ' + childElementCount);
					largeTxtArray = [];
				} else {
					$(this).addClass('menu-l2-normal ' + childElementCount);
					largeTxtArray = [];
				}
			}
		});
	}
}

MenuWidthCalc()

// --- Subpage topbar ---



// --- Fixed topbar (on scroll down) ---
function fixedTopbar() {

	let subNav = $('.sub-navigation');

	if (subNav.length <= 0) {

		let headerTop = $('.header-topbar');

		if ($(window).scrollTop() > 1) {

			headerTop.addClass('fixed');

		} else {

			headerTop.removeClass('fixed');

		}
	} else {

		if ($(window).width() > 768) {

			let subNavTop = $('.sub-navigation-wrapper').offset().top;

			let cgAdminBar = $('#wpadminbar');

			let adminBarHeight = 0;

			if (cgAdminBar.length > 0) {

				adminBarHeight = cgAdminBar.outerHeight();
			}

			subNavTop -= adminBarHeight;

			if ($(window).scrollTop() > subNavTop) {

				subNav.addClass('fixed');

			} else {

				subNav.removeClass('fixed');
			}
		}
	}
}

$(window).resize(debounce(
	function () {
		fixedTopbar();
	}, 100));

$(window).scroll(function () {
	fixedTopbar()
})
fixedTopbar()



// --- Mobile menu (mobile) ---
// Open/Close navigation - Mobile Menu will not closed until user clicks on close icon.

// Keep topbar-wrapper size when topbar is fixed

function topbarResizer() {

	// Do not affect main page at all
	if (!$('body').hasClass('body--home')) {
		var wasFixed = 0,
			time = 0

		if ($('.header-topbar').hasClass('fixed')) {
			wasFixed = 1;
			$('.header-topbar').removeClass('fixed');
			time = 300;
		}

		// let cgSubNavigationWrapper = $( '.sub-navigation-wrapper' );

		// if ( cgSubNavigationWrapper.length > 0 ) {
		//
		// 	let topSpacing = cgSubNavigationWrapper.innerHeight() / 2;
		//
		// 	let headerTopBarHeight = $( '.header-topbar' ).outerHeight();
		//
		// 	let cgAdminBar = $( '#wpadminbar' );
		//
		// 	let adminBarHeight = 0;
		//
		// 	if ( cgAdminBar.length > 0 ) {
		//
		// 		adminBarHeight = cgAdminBar.outerHeight();
		// 	}
		//
		// 	setTimeout( function () {
		//
		// 		// Main pages other than home: breadcrumbs are affected.
		// 		if ( $( 'body' ).hasClass( 'body--main' ) ) {
		//
		// 			let windowWidth = $( window ).width();
		//
		// 			if ( windowWidth > 1200 ) {
		//
		// 				cgSubNavigationWrapper.css( 'top', headerTopBarHeight + adminBarHeight );
		//
		// 			} else {
		//
		// 				let headerMobile = $( '.header-mobile-bar' );
		//
		// 				if ( headerMobile.length > 0 ) {
		//
		// 					cgSubNavigationWrapper.css( 'top', ( headerMobile.innerHeight() - topSpacing ) + adminBarHeight );
		// 				}
		// 			}
		// 		} else {
		//
		// 			$( '.header-topbar-wrapper' ).height( $( '.header-topbar' ).outerHeight() + adminBarHeight );
		// 		}
		//
		// 		if ( wasFixed ) {
		// 			$( '.header-topbar' ).addClass( 'fixed' );
		// 		}
		// 	}, time );
		// }
	}
}

$(document).ready(function () {
	$(window).resize(debounce(function () {
		topbarResizer();
	}, 100));
	topbarResizer();
});

//Breadcrum will hide on click

const headerTopBarNode = document.querySelector('.header-topbar');
headerTopBarNode.addEventListener('click', () => {
	const subNavigationNode = document.querySelector('.sub-navigation-wrapper');
	if (subNavigationNode) {
		subNavigationNode.classList.add('below-header');
	}
});
